import { differenceInMilliseconds } from 'date-fns';
import { MILLISECONDS_IN_DAY } from '../../constants';
import type { ScheduleSolversTimeConfigType } from '../../types';

export const dailyTime = ({
  startDate,
  endDate,
  userDate,
  freq = 1
}: ScheduleSolversTimeConfigType) => {
  const viewDuration = differenceInMilliseconds(endDate, startDate);
  const fromNowToStart = differenceInMilliseconds(userDate, startDate);

  const frequency = MILLISECONDS_IN_DAY * freq;
  const timeFromStart = fromNowToStart % frequency;

  return viewDuration - timeFromStart;
};
